import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="card max-w-3xl mx-auto space-y-4" data-testid="privacy-page">
      <h1 className="text-base md:text-lg font-semibold">Privacy Notice</h1>
      <p className="text-muted-foreground">
        GDI Academy stores your email address, display name, learning progress, quiz/session
        attempts, and optional lesson feedback so you can learn securely across sessions.
      </p>
      <p className="text-muted-foreground">
        We do not ask for passport numbers, driver licence numbers, medical information, or other
        sensitive identity documents for learner self-signup.
      </p>
      <p className="text-muted-foreground">
        GDI Academy accounts are separate from the GDI operational app. Academy does not receive
        GDI student IDs, lesson IDs, billing data, or session tokens, and does not write to GDI.
      </p>
      <p className="text-muted-foreground">
        Contact{" "}
        <a className="underline" href="mailto:info@getdrivinginstructor.co.nz">
          info@getdrivinginstructor.co.nz
        </a>{" "}
        for privacy questions, account deletion requests, or data-retention queries.
      </p>
      <Link to="/register" className="btn-outline inline-flex" data-testid="privacy-back-register">
        Back to signup
      </Link>
    </div>
  );
}
